import { useEffect, useState } from 'react';
import { SubmitHandler } from 'react-hook-form';

import { CasBaseDialog, CasButton } from 'src/compass/shared/components';
import { CasSecondaryButton } from 'src/compass/shared/components/CasButton/CasSecondaryButton';
import CasReactHookForm, {FormMethodType, ICasReactHookFormProps} from 'src/compass/shared/components/CasForm/CasReactHookForm';
import { ICasBaseDialog } from '../CasDialog/CasBaseDialog';

export interface ICasRHFFormDialogProps extends Omit<ICasReactHookFormProps, 'onSubmit'> {
  open: boolean;
  title: string | React.ReactNode;
  maxWidth?: ICasBaseDialog['maxWidth'],
  fullScreen?: ICasBaseDialog['fullScreen'],
  onClose: VoidFunction;
  onSubmit: SubmitHandler<any>;
  //
  submitButtonLabel?: string;
  submitButton?: React.ElementType;
  buttonProps?: Partial<React.ComponentProps<typeof CasButton>>;
}

export default function CasReactHookFormDialog({
  open,
  title,
  maxWidth,
  fullScreen,
  schema,
  defaultValues = {},
  children,
  onClose,
  onSubmit,
  // 
  setFormMethods: setFormMethodsByParent,
  compressed,
  // submit button related props
  submitButtonLabel = 'Submit',
  submitButton: SubmitButton = CasButton,
  buttonProps = {},
}: ICasRHFFormDialogProps) {
  const [formMethods, setFormMethods] = useState<FormMethodType>(null);

  const handleSubmit = () => formMethods?.handleSubmit(onSubmit)();

  useEffect(() => {
    if (setFormMethodsByParent) setFormMethodsByParent(formMethods);
  }, [formMethods, setFormMethodsByParent]);

  return (
    <CasBaseDialog
      {...{ title, open, onClose, maxWidth, fullScreen }}
      actions={
        <>
          <CasSecondaryButton onClick={onClose}>Cancel</CasSecondaryButton>
          <SubmitButton onClick={handleSubmit} {...buttonProps}>
            {submitButtonLabel}
          </SubmitButton>
        </>
      }
    >
      <CasReactHookForm {...{ schema, defaultValues, setFormMethods, compressed }}>
        {children}
      </CasReactHookForm>
    </CasBaseDialog>
  );
}
